module.exports = __webpack_public_path__ + "static/img/G1_V1_cut.bcf0e02.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation/img_1024/G1_V1_cut.png
// module id = xQ6C
// module chunks = 1